import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestQuizUpdate } from "./quizUpdate.request";
import { QuizUpdateRequestBody } from "./quizUpdate.types";

const useQuizUpdate = (
  options?: MutationOptions<
    void,
    ApiServiceError<ApiError>,
    QuizUpdateRequestBody
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestQuizUpdate,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.setQueryData(["content-quiz"], {
        content: {
          correctAnswersNeededToPass: variables.correctAnswersNeededToPass,
          quizzes: variables.quizzes
        }
      });
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useQuizUpdate;
